import { useRange } from 'react-instantsearch';
import React, { useState, useEffect } from 'react';
import './CustomRangeInput.css';

export const CustomRangeInput = ({ attribute }) => {
    const { start, range, refine } = useRange({ attribute });
  
    const [minValue, setMinValue] = useState('');
    const [maxValue, setMaxValue] = useState('');
  
    useEffect(() => {
        const [startMin, startMax] = start;
      
        if (startMin === undefined && startMax === undefined) {
          setMinValue('');
          setMaxValue('');
        } else {
          setMinValue(startMin ?? '');
          setMaxValue(startMax ?? '');
        }
      }, [start[0], start[1]]);
      
  
    const handleSubmit = (e) => {
      e.preventDefault();
  
      const min = minValue ? Number(minValue) : undefined;
      let max = maxValue ? Number(maxValue) : undefined;
  
      if (max !== undefined && max > 0) {
        max = 0;
        setMaxValue('0');
      }
  
      refine([min, max]);
    };  

  return (
    <div className="custom-range-input">
      <form className="custom-range-input__form" onSubmit={handleSubmit}>
        <label className="custom-range-input__label">
          <input
            className="custom-range-input__input custom-range-input__input--min"
            type="number"
            value={minValue}
            onChange={(e) => setMinValue(e.target.value)}
            placeholder={range.min?.toString() || 'Mín'}
            step="any"
          />
        </label>

        <span className="custom-range-input__separator">to</span>

        <label className="custom-range-input__label">
          <input
            className="custom-range-input__input custom-range-input__input--max"
            type="number"
            value={maxValue}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || Number(value) <= 0) {
                setMaxValue(value);
              }
            }}
            placeholder="0"
            step="any"
          />
        </label>

        <button className="custom-range-input__submit" type="submit">
          Go
        </button>
      </form>
    </div>
  );
};
